<template>
  <div class="page page-bg">
    <div class="weui-msg">
      <div class="weui-msg__icon-area">
        <img src="../../assets/images/qyq.png" />
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">华商企业圈</h2>
      </div>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <launch-weapp />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LaunchWeapp from "@/components/button/LaunchWeapp.vue";

export default {
  components: {
    LaunchWeapp,
  },
};
</script>